import { render } from "./Team.vue?vue&type=template&id=46b6e0f0&ts=true"
import script from "./Team.vue?vue&type=script&lang=tsx"
export * from "./Team.vue?vue&type=script&lang=tsx"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__